<template>
    <el-popover placement="top" width="160" v-model="visible">
        <p>{{message}}</p>
        <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="onCancel">取消</el-button>
            <el-button type="primary" size="mini" @click="onConfirm">确定</el-button>
        </div>
        <el-button slot="reference" :size="size" :type="type">
            <slot></slot>
        </el-button>
    </el-popover>
</template>

<script>
export default {
    props:{
        size:{
            type:String
        },
        type:{
            type: String
        },
        message:{
            type: String,
            default: '确认要执行该操作吗？'
        }
    },
    data: function(){
        return {
            visible: false
        };
    },
    methods:{
        onCancel(){
            this.$emit('cancel');
            this.visible = false;
        },
        onConfirm(){
            this.$emit('confirm');
            this.visible = false;
        }
    }
};
</script>